<template>

  <div id="userLayout" :class="['user-layout-wrapper', isMobile && 'mobile']">
    <div class="container">
      <div class="user-layout-lang">
        <select-lang class="select-lang-trigger" />
      </div>
      <div class="user-layout-content">

        <router-view />

        <!--        <div class="footer">
          <div class="links">
            <a href="_self">帮助</a>
            <a href="_self">隐私</a>
            <a href="_self">条款</a>
          </div>
          <div class="copyright">
            Copyright &copy; 2018 vueComponent
          </div>
        </div> -->
      </div>
    </div>
    <div id="particlesId"></div>
    <div class="ip-text-div" >
      <a class="ip-text" target="_blank" href="https://beian.miit.gov.cn/">粤ICP备2023093872号-2</a>
      <img class="icon-class" src="../assets/images/icon.png" alt="">
      <a class="ip-text" href="https://beian.mps.gov.cn/#/query/webSearch?code=44011202003331" rel="noreferrer" target="_blank">粤公网安备44011202003331号</a>˜
    </div>
  </div>
</template>

<script>
import { deviceMixin } from '@/store/device-mixin'
import SelectLang from '@/components/SelectLang'
import particles from 'particles.js'
import PcParticles from "./particles.json"

export default {
  name: 'UserLayout',
  components: {
    SelectLang
  },
  mixins: [deviceMixin],
  mounted () {
    document.body.classList.add('userLayout')
    particlesJS("particlesId",PcParticles)
  },
  beforeDestroy () {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="less" scoped>
#userLayout.user-layout-wrapper {
  height: 100%;

  &.mobile {
    .container {
      .main {
        max-width: 368px;
        width: 98%;
      }
    }
  }
  #particlesId{
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: #159AA3;
  }
  .ip-text-div {
    width: 100%;
    text-align: center;
    bottom: 24px;
    position: absolute;
    .ip-text {
      color: #FFFFFF;
      text-align: center;
      z-index: 999;
  
      &:hover {
        color: #0f77d7;
      }
    }
  }
  .icon-class {
    width: 18px;
    height: 18px;
    vertical-align: text-top;
    margin-right: 7px;
    margin-left: 7px;
  }
  
  .container {
    width: 100%;
    min-height: 100%;
    z-index: 12;
    // background: #f0f2f5 url(~@/assets/background.svg) no-repeat 50%;
    background-size: 100%;
    //padding: 50px 0 84px;
    pointer-events: none;
    position: relative;

    .user-layout-lang {
      width: 100%;
      height: 40px;
      line-height: 44px;
      text-align: right;

      .select-lang-trigger {
        cursor: pointer;
        padding: 12px;
        margin-right: 24px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        vertical-align: middle;
      }
    }

    .user-layout-content {
      padding: 32px 0 24px;

      .top {
        text-align: center;

        .header {
          height: 44px;
          line-height: 44px;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            height: 44px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
          }

          .title {
            font-size: 33px;
            color: rgba(0, 0, 0, .85);
            font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
            font-weight: 600;
            position: relative;
            top: 2px;
          }
        }
        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }

        .main {
        min-width: 260px;
        margin: 0 auto;
        width: 486px;
        height: 600px;
        background: #ffffff;
        border-radius: 16px 16px 16px 16px;
        opacity: 1;
        border: 1px solid #e1e1e1;
        padding: 60px;
        margin-top: 60px;
      }

      .footer {
        // position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 48px 0 24px;
        text-align: center;

        .links {
          margin-bottom: 8px;
          font-size: 14px;
          a {
            color: rgba(0, 0, 0, 0.45);
            transition: all 0.3s;
            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }
        .copyright {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
        }
      }
    }

    a {
      text-decoration: none;
    }
  }
}
</style>
